<template>
    <v-ons-page class="textPage">
        <TopBar back="true"></TopBar>
        <audio id="audio">
            <source :src="item.audio" type="audio/mpeg"/>
            Your  does not support the audio element.
        </audio>
        <div class="fullImage ">
            <img class="art" :src="item.img"/>
        </div>
        <div class="textContent" v-html="item.description">

        </div>
        <img class="imgCredit" :src="item.imgCredit"/>
       
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'

    export default {
        name: 'text',
        props: [
            'item'
        ],
        components: {
            TopBar
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    /*.fullImage {*/
        /*height: 54.5%;*/
        /*overflow: hidden;*/
    /*}*/
    .fullImage {
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .fullImage img {

        /*position: relative;*/
        /*top: 50%;*/
        /*transform: translateY(-50%);*/
        width: auto;
        height: 77vw;
    }

    .art {
        width: 100%;
    }

    .textContent {
        margin: 10% 10% 10% 5%;
        /*padding: 0 10%;*/
        height: 31%;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/TextPage.vue